import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SubmissionStateService } from '../../services/submission-state.service';

@Component({
  selector: 'app-submit-button',
  templateUrl: './submit-button.component.html',
})
export class SubmitButtonComponent {
  @Input() label!: string;
  @Input() isSubmitting = false;
	@Input() processName!: string;
  @Input() icon = '';
  @Input() type = 'submit';
  @Input() styleClass = '';
  @Input() tooltip = '';
	@Input() validationMessage: string | null = null;

  // Add output for cancel event
  @Output() cancel = new EventEmitter<void>();

	constructor(private submissionState: SubmissionStateService) {}

  onCancel() {
		this.isSubmitting = false;
		this.submissionState.setSubmitting(this.processName, false);
    this.cancel.emit();
  }
}